import React from 'react'

/**
 * `width : height = 25 : 16` or `28 : 33` のアスペクト比を保ったまま画像を表示するコンポーネント
 * - width : height = 25 : 16 => height / width = 480 / 750 = 0.64が基準
 * - width : height = 28 : 33 => height / width = 990 / 840 = 1.178...が基準
 */
export const Image = ({
  src,
  aspectRatio = '25/16',
  fit = 'default',
}: { src: string; aspectRatio?: '25/16' | '28/33'; fit?: 'default' | 'width-fit' }) => {
  if (fit === 'default') {
    return (
      <div className="relative w-full h-full flex items-center justify-center">
        <img src={src} alt="" className="max-w-full max-h-full w-full h-full object-contain" style={{ aspectRatio }} />
      </div>
    )
  } else if (fit === 'width-fit') {
    return <img src={src} alt="" className="w-full h-auto" />
  }
  return null
}
